import { IMotorCarrier } from './entity'
import { TEAM_MEMBER_ROLE_TYPES, TEAM_MEMBER_USER_TYPES } from './teamMember'

export const ACTIVE_MOTOR_CARRIER_STATES = [
  'activated',
  'application_submitted',
  'expired_insurance',
  'fresh',
  'in_review',
  'new',
  'pending',
] as const

export const INACTIVE_MOTOR_CARRIER_STATES = [
  'out_of_service',
  'conditional',
  'cancelled',
  'probation',
  'do_not_use',
  'cannot-use',
  'inactive',
  'other',
] as const

export type ActiveMotorCarrierState = typeof ACTIVE_MOTOR_CARRIER_STATES[number]
export type InactiveMotorCarrierState = typeof INACTIVE_MOTOR_CARRIER_STATES[number]
export type MotorCarrierState = ActiveMotorCarrierState | InactiveMotorCarrierState

export interface IGetCurrentUsersMotorCarriersResponse {
  motorCarriers: IMotorCarrier[]
}

export interface IGetMotorCarriersResponse {
  motorCarriers: IMotorCarrier[]
}

export interface ISearchMotorCarriersResponse {
  motorCarrier: IMotorCarrier
}

export interface IMotorCarrierApplication {
  id: number
  state?: MotorCarrierState
  hasAddedReferences: boolean
  hasSignedBca: boolean
  hasUploadedDocuments: boolean
  hasW9: boolean
  hasInsurance: boolean
  isProject44Enabled?: boolean
}

export interface IMotorCarrierMembership {
  createdAt: Date
  role: TEAM_MEMBER_ROLE_TYPES
  userType: TEAM_MEMBER_USER_TYPES
  usersCount: number
}

export interface IMotorCarrierRequestedMembership {
  createdAt: Date
  sanitizedRecipientEmails: String[]
}

export interface IUserMotorCarrier {
  motorCarrier: IMotorCarrier
  carrierApplication?: IMotorCarrierApplication
  membership: IMotorCarrierMembership
  requestedMembership?: IMotorCarrierRequestedMembership
}

export interface IGetUserMotorCarriers {
  motorCarriersForUser: IUserMotorCarrier[]
}
